
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[alias]",
      function () {
        return require("private-next-pages/s/[alias].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[alias]"])
      });
    }
  